import convert from 'convert-units'

let ret = []

for(let m of ['g','kg','oz','lb']){
    ret.push(convert().describe(m))
}

for(let v of ['ml','l','fl-oz','pnt','cup','tsp','Tbs']){
    ret.push(convert().describe(v))
}

export default ret